export { default } from './InputCheckDuplicate'
